<template lang="pug">
    .keyIcons-container(:class="[spacingTop, spacingBottom, boxColor]")
      .container.mx-auto.px-12
        .keyIcons-wrap
          Panel(
            v-for="( panel, i ) in accordion"
            :key="panel.id"
            :index="i"
            :panel="panel"
          )
</template>

<script>
//import AOS from 'aos';
import { get, cloneDeep } from '@/helpers';
import Panel from './Panel';

export default {
  name: 'KeyIcons',
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  components: {
    Panel
  },
  computed: {
    boxColor() {
      let boxColor = 'blue';

      if (this.section.settings && this.section.settings.length) {
        const setting = this.section.settings.find(setting => setting.key === 'boxColor');
        if (setting && setting.value !== undefined) boxColor = setting.value;
      }
      return boxColor;
    },

    spacingTop() {
      let spacingTop = 'spacingTopStandard';

      if (this.section.settings && this.section.settings.length) {
        const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
        if (setting && setting.value !== undefined) spacingTop = setting.value;
      }
      return spacingTop;
    },

    spacingBottom() {
      let spacingBottom = 'spacingBottomStandard';

      if (this.section.settings && this.section.settings.length) {
        const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
        if (setting && setting.value !== undefined) spacingBottom = setting.value;
      }
      return spacingBottom;
    },

    accordion() {
      let accordion = this.section.contents || [];
      return cloneDeep(accordion).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
    }
  }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.keyIcons-container
  @apply py-12
  background-color: $isserstedt-grey

  .keyIcons-wrap
    @apply grid grid-cols-1 gap-8
    @media screen and (min-width: 450px )
      @apply grid-cols-3

.blue
  &::v-deep
    .box
      background-color: $isserstedt-blue2
.yellow
  &::v-deep
    .box
      background-color: $isserstedt-yellow
</style>
